module.exports = new __parcel__URL__("shop_machines_medical_academy.ba2e2a64.png").toString();